import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { ADD_REMOVE_ICON_TYPE } from './AddRemoveIcon.constants';
import { getAddIconStyles } from './AddRemoveIcon.styles';

const AddRemoveIcon = ({
  color,
  width = 20,
  height = 20,
  borderRadius = 4,
  customStyles,
  type = ADD_REMOVE_ICON_TYPE.ADD,
}) => <Box sx={getAddIconStyles({ color, width, height, borderRadius, customStyles, type })} />;

AddRemoveIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  borderRadius: PropTypes.number,
  customStyles: PropTypes.object,
  type: PropTypes.oneOf(Object.values(ADD_REMOVE_ICON_TYPE)),
};

export default AddRemoveIcon;
